<form nz-form class="ant-advanced-search-form" [formGroup]="form">
  <div nz-row nzGutter="24">
    <ng-container *ngFor="let field of fields | slice: 0 : numberCollapse" >
      <div nz-col nzSm="12" nzMd="6" [nzLg]="field.numberCol" [nzXl]="field.numberCol">
        <nz-form-item>
          <nz-form-label nzSpan="24" *ngIf="field.type !== type.CHECKBOX" [nzFor]="field.controlName">{{ field.label }}</nz-form-label>
          <nz-form-control nzSpan="24" [nzErrorTip]="errorTpl" >
            <ng-container *ngIf="field.type === type.INPUT">
              <input-field
                [formControlName]="field.controlName"
                [field]="field">
              </input-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.SELECT">
              <select-field
                [formControlName]="field.controlName"
                [field]="field"
              >
              </select-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.DATETIME">
              <dataTime-field
                [formControlName]="field.controlName"
                [field]="field"
              >
              </dataTime-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.RADIO">
              <radio-checkbox-field
              [formControlName]="field.controlName"
              [field]="field"
              >
              </radio-checkbox-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.CHECKBOX">
              <checkbox-field
                [formControlName]="field.controlName"
                [field]="field"
              >
              </checkbox-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.NUMBER">
              <number-field
              [formControlName]="field.controlName"
              [field]="field"
              >
              </number-field>
            </ng-container>
            <ng-container *ngIf="field.type === type.SELECT_AUTOCOMPLETE">
              <asc-autocomplete
                [ascModel]="form.controls[field.controlName]"
                [valueChange]="field.value"
                [placeholder]="field.placeholder" 
                [formControlName]="field.controlName"
                [getListAC]="field.autoComplete"
                (ascModelChange)="changeSelected($event)"
                [disabled]="field.disable"
              >
              </asc-autocomplete>
            </ng-container>
          </nz-form-control>
        </nz-form-item>
      </div>
      <ng-template #errorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          Vui lòng nhập trường thông tin bắt buộc!
        </ng-container>
        <ng-container *ngFor="let i of field.validatorCustom">
          <ng-container *ngIf="control.hasError(i.nameValidator)">
            {{ i.messegaError }}
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!isCollapse_t">
      <ng-container *ngFor="let field of fields | slice : numberCollapse : fields.length" >
        <div nz-col nzSm="12" nzMd="6" [nzLg]="field.numberCol" [nzXl]="field.numberCol">
          <nz-form-item>
            <nz-form-label nzSpan="24" *ngIf="field.type !== type.CHECKBOX" [nzFor]="field.controlName">{{ field.label }}</nz-form-label>
            <nz-form-control nzSpan="24" [nzErrorTip]="errorTpl2" >
              <ng-container *ngIf="field.type === type.INPUT">
                <input-field
                  [formControlName]="field.controlName"
                  [field]="field">
                </input-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.SELECT">
                <select-field
                  [formControlName]="field.controlName"
                  [field]="field"
                >
                </select-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.DATETIME">
                <dataTime-field
                  [formControlName]="field.controlName"
                  [field]="field"
                >
                </dataTime-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.RADIO">
                <radio-checkbox-field
                [formControlName]="field.controlName"
                [field]="field"
                >
                </radio-checkbox-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.CHECKBOX">
                <checkbox-field
                  [formControlName]="field.controlName"
                  [field]="field"
                >
                </checkbox-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.NUMBER">
                <number-field
                [formControlName]="field.controlName"
                [field]="field"
                >
                </number-field>
              </ng-container>
              <ng-container *ngIf="field.type === type.SELECT_AUTOCOMPLETE">
                <asc-autocomplete
                  [valueChange]="field.value"
                  [ascModel]="form.controls[field.controlName]"
                  [placeholder]="field.placeholder" 
                  [formControlName]="field.controlName"
                  [getListAC]="field.autoComplete"
                  (ascModelChange)="changeSelected($event)"
                  [disabled]="field.disable"
                >
                </asc-autocomplete>
              </ng-container>
            </nz-form-control>
          </nz-form-item>
        </div>
        <ng-template #errorTpl2 let-control>
          <ng-container *ngIf="control.hasError('required')">
            Vui lòng nhập trường thông tin bắt buộc!
          </ng-container>
          <ng-container *ngFor="let i of field.validatorCustom">
            <ng-container *ngIf="control.hasError(i.nameValidator)">
              {{ i.messegaError }}
            </ng-container>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
    <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
      <div style="visibility: hidden; margin-top: 5px">i</div>
    </div>
  </div>
  <div nz-row>
    <div nz-col [nzSpan]="24" class="search-area">
      <page-btn-search
        (clear)="clear()"
        (search)="search()"
        (toggleCollapse)="toggleCollapse()"
        [isCollapse]="isCollapseBtn"
        [isClearBtn]="isClearBtn"
        [isCollapseBtn]="isCollapseBtn"
      ></page-btn-search>
    </div>
  </div>
</form>

